export default "__VITE_ASSET__w7QCzHso__"